import { ArrowUpRight, BookOpen, Images } from "lucide-react";
import { EncabezadoSeccion, Reveal, Marquee } from "../../shared/motion";

export function EnlacesSeccion({ datos, seccion }) {
  const enlaces = datos.enlaces || [];
  if (enlaces.length === 0) return null;

  return (
    <section className="fe-seccion" aria-label={seccion.titulo}>
      <div className="fe-seccion-interior">
        <EncabezadoSeccion p="fe" etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid="fe-titulo-enlaces" />
        <Reveal>
          <div className="fe-enlaces">
            {enlaces.map((enlace, i) => (
              <a
                key={i}
                className="fe-boton fe-boton--linea"
                href={enlace.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`fe-enlace-adicional-${i}`}
              >
                {enlace.texto}
                <ArrowUpRight strokeWidth={1.8} />
              </a>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function AccesosSeccion({ datos, seccion, acciones }) {
  const accesos = datos.accesos || {};
  const items = [
    accesos.libroFirmas && {
      icono: BookOpen,
      datos: accesos.libroFirmas,
      alHacer: acciones?.onAbrirLibroFirmas,
      testid: "fe-boton-libro-firmas",
    },
    accesos.album && {
      icono: Images,
      datos: accesos.album,
      alHacer: acciones?.onAbrirAlbumColaborativo,
      testid: "fe-boton-album",
    },
  ].filter(Boolean);
  if (items.length === 0) return null;

  return (
    <section className="fe-seccion" aria-label={seccion.titulo}>
      <div className="fe-seccion-interior">
        <EncabezadoSeccion p="fe" etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid="fe-titulo-accesos" />
        <Reveal>
          <div className="fe-accesos">
            {items.map((item, i) => (
              <button key={i} type="button" className="fe-acceso" onClick={() => item.alHacer?.()} data-testid={item.testid}>
                <item.icono strokeWidth={1.8} />
                <span>
                  <span className="fe-acceso-titulo">{item.datos.titulo}</span>
                  <span className="fe-acceso-texto" style={{ display: "block" }}>
                    {item.datos.texto}
                  </span>
                </span>
              </button>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function CierreSeccion({ datos }) {
  const { protagonista, evento, legal } = datos;

  return (
    <>
      <Marquee
        p="fe"
        textos={[protagonista.nombre, evento.fechaCorta, evento.ciudad]}
      />
      <section className="fe-seccion fe-cierre" data-testid="fe-cierre">
        <div className="fe-seccion-interior">
          <Reveal>
            <p className="fe-cierre-mensaje">{protagonista.mensajeCierre}</p>
            <p className="fe-cierre-nombre">{protagonista.nombre}</p>
            <div className="fe-cierre-legal">
              <span>{legal?.marca}</span>
              {legal?.urlPrivacidad && (
                <a href={legal.urlPrivacidad} target="_blank" rel="noopener noreferrer" data-testid="fe-enlace-privacidad">
                  {legal.textoPrivacidad || "Privacidad"}
                </a>
              )}
              {legal?.urlCondiciones && (
                <a href={legal.urlCondiciones} target="_blank" rel="noopener noreferrer" data-testid="fe-enlace-condiciones">
                  {legal.textoCondiciones || "Condiciones"}
                </a>
              )}
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
